var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68638 12.0004H0.198436V3.98843H2.68638V12.0004ZM1.44091 2.89553C0.645452 2.89553 0 2.23637 0 1.44091C0 1.05876 0.15181 0.692255 0.422032 0.422032C0.692255 0.15181 1.05876 0 1.44091 0C1.82306 0 2.18956 0.15181 2.45978 0.422032C2.73001 0.692255 2.88182 1.05876 2.88182 1.44091C2.88182 2.23637 2.23637 2.89553 1.44091 2.89553ZM11.9979 12.0004H9.51548V8.10029C9.51548 7.17068 9.49662 5.97879 8.22201 5.97879C6.92853 5.97879 6.7301 6.98854 6.7301 8.03343V12.0004H4.24472V3.98843H6.63067V5.08132H6.66538C6.99754 4.45173 7.80885 3.78742 9.01918 3.78742C11.5371 3.78742 12 5.44562 12 7.59927V12.0004H11.9979Z",
    fill: "url(#paint0_linear_2590_44835)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2590_44835",
    x1: 6,
    y1: -2.16008,
    x2: 6,
    y2: 13.9205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c7486ae42ce7d42e9653bcae5fb01a46.svg";
export { ForwardRef as ReactComponent };